<template>
  <div class="question">
    <h4 class="question__title">
      Q {{ question_index + 1 }}. {{ question.question }}
    </h4>
    <div class="question__score">
      <ul>
        <li
          v-for="score in scoreRange"
          v-bind:key="score"
          @click="setAnswer(score)"
          v-bind:class="question.answer == score ? 'active' : ''"
        >
          <p>{{ score }}</p>
        </li>
      </ul>
      <div class="question__score__labels">
        <p
          class="question__score__labels__label question__score__labels__label--disagree"
        >
          {{ hcData.label_strongly_disagree }}
        </p>
        <p
          class="question__score__labels__label question__score__labels__label--agree"
        >
          {{ hcData.label_strongly_agree }}
        </p>
      </div>
    </div>
    <div class="question__nav">
      <p v-if="section_index == 0 && question_index == 0">
        &lt; {{ hcData.label_previous }}
      </p>
      <a v-else href="#" @click.prevent="showPrevQuestion()"
        >&lt; {{ hcData.label_previous }}</a
      >
    </div>
  </div>
</template>
<script>
import store from "../store";

export default {
  store: store,
  props: ["question", "question_index", "section_index"],
  data: function() {
    return {
      scoreRange: [1, 2, 3, 4, 5, 6, 7]
    };
  },
  computed: {
    hcData() {
      return store.getters.hcData;
    },
    isFinished() {
      return store.getters.isFinished;
    }
  },
  methods: {
    showNextQuestion() {
      store.commit("nextQuestion");
      let newPos = 0;
      if (!this.isFinished) {
        newPos = this.getTopPosition() - 100 + "vh";
      }
      document.querySelector(".questions-panel__inner").style.transform =
        "translateY(" + newPos + ")";
      this.scrollViewport();
      store.commit("setProgressBarPosY");
    },
    showPrevQuestion() {
      store.commit("prevQuestion");
      let newPos = this.getTopPosition() + 100 + "vh";
      document.querySelector(".questions-panel__inner").style.transform =
        "translateY(" + newPos + ")";
      this.scrollViewport();
      store.commit("setProgressBarPosY");
    },
    getTopPosition() {
      let topPos = document.querySelector(".questions-panel__inner").style
        .transform;
      topPos = topPos.replace("translateY(", "").replace("vh)");
      // If we dont have a top pos, set it to 0
      topPos = topPos ? parseInt(topPos) : 0;
      return topPos;
    },
    setAnswer(score) {
      this.question.answer = score;
      this.showNextQuestion();
    },
    /**
     * Move the viewport to the question panel
     */
    scrollViewport() {
      var VueScrollTo = require("vue-scrollto");

      VueScrollTo.scrollTo(
        document.querySelector(".questions-panel__inner"),
        500,
        {
          container: "#health_check__container"
        }
      );
    }
  }
};
</script>

<style lang="scss">
.question {
  &__title {
    margin: 50px 0;
    font-weight: 600;
    color: #22252a;
    font-size: 19px;
    line-height: 28px;
    padding-left: 63px;
    height: 60px;

    @media (max-width: 767px) {
      margin: 43px 0 46px;
      padding-left: 0;
      height: auto;
      font-size: 17px;
      line-height: 26px;
    }
  }

  &__score {
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0 48px 0 58px;
      justify-content: space-between;

      @media (max-width: 767px) {
        padding: 0;
      }

      li {
        background-color: #f2f3f3;
        display: block;
        width: 42px;
        height: 42px;
        flex: 0 0 42px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        @media (max-width: 767px) {
          flex-basis: 32px;
          height: 32px;

          p {
            font-size: 14px;
            line-height: 15px;
            margin-top: 4px !important;
          }
        }

        p {
          font-size: 15px;
          line-height: 15px;
          margin: 0;
          letter-spacing: -0.35px;
          margin-top: 2px !important;
        }

        &:hover,
        &:focus,
        &.active {
          background-color: #0000ff;
          color: white;

          p {
            font-weight: 600;
          }
        }
      }
    }

    &__labels {
      display: flex;
      margin: 15px 20px 0 20px;
      justify-content: space-between;

      @media (max-width: 767px) {
        margin: 14px 0;
      }

      &__label {
        font-size: 14px;
        letter-spacing: -0.35px;
        font-weight: 600;

        @media (max-width: 767px) {
          font-size: 14px;
        }

        &--agree {
        }

        &--disagree {
        }
      }
    }
  }

  &__nav {
    margin-top: 56px;
    font-size: 16px;

    p {
      color: #22252a;
    }

    a {
      color: #0000ff;
    }
  }
}
</style>
